import axios from "axios";

export const batchService = {
  /** Batch */
  changeBatchStatusApprove: ( id ) => axios.patch(`/batch/${id}/status/approve`, {}, {auth:true}),
  changeBatchStatusUnpaid: ( id ) => axios.patch(`/batch/${id}/status/unpaid`, {}, {auth:true}),
  /** End */
};